const isAndroid = (window: Window) =>
  Boolean(window.navigator.userAgent.match(/Android/i));

export default isAndroid;
